import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: () => import('@/views/OverviewView.vue') },
    { path: '/campaigns', component: () => import('@/views/CampaignsView.vue') },
    { path: '/campaigns/board', component: () => import('@/views/SegmentBoardView.vue') },
    { path: '/campaigns/:key(.*)', component: () => import('@/views/CampaignView.vue') },
    { path: '/leads', component: () => import('@/views/LeadsView.vue') },
    { path: '/leads/performance', component: () => import('@/views/LeadPerformanceView.vue') },
    { path: '/leads/nurture', component: () => import('@/views/NurtureView.vue') },
    { path: '/leads/closeouts', component: () => import('@/views/CloseoutsView.vue') },
    { path: '/leads/checks', component: () => import('@/views/LeadChecksView.vue') },
    { path: '/paid', component: () => import('@/views/PaidView.vue') },
    { path: '/paid/linkedin', component: () => import('@/views/LinkedInAdsView.vue') },
    { path: '/contacts', component: () => import('@/views/ContactsView.vue') },
    { path: '/management', component: () => import('@/views/ManagementView.vue') },
    { path: '/board', redirect: '/management' },
    { path: '/contacts/:id', component: () => import('@/views/ContactView.vue') },
  ],
})
